var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"throttle",rawName:"v-throttle",value:([_vm.shareButtonClick,5000,`click`]),expression:"[shareButtonClick,5000,`click`]"}],staticStyle:{"margin-left":"-385px"}},[_c('share',{attrs:{"network":"facebook","config":_vm.share_config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }